export default __webpack_public_path__ + "static/media/1029.060c35dd.png";